module.exports = __webpack_public_path__ + "static/media/collapse-arrow.7dbc8af4.svg";